import React, { Component } from 'react';
import Page from '../containers/page';
import { Link } from 'react-router-dom';

import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import image from '../assets/images/account-cover.png';
import imageMobile from '../assets/images/account-cover.png';
import AccountNav from '../components/accountNav';
import image1 from '../assets/images/account-image1.png';
import image2 from '../assets/images/account-image2.png';
import image3 from '../assets/images/account-image3.png';
import image4 from '../assets/images/account-image4.png';
import backyard from '../assets/images/account-backyard.png';


class AccountPageL extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.initialData,
      controlPanel: true,
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const showBackyard = this.props.uData?.showBackyard || false;
    return (
      <div className="account-page">
        <section className="test">
          <img
            src={
              typeof window !== 'undefined' && window.innerWidth < 768
                ? imageMobile
                : image
            }
          />
          <div className="test-content">
            <h1>{'MINA SIDOR'.translate(this.props.lang)}</h1>
          </div>
        </section>

        <Container>
          <Row>
            <Col lg="4">
              <AccountNav {...this.props} />
            </Col>
            <Col lg="8">
              <div className="account-container">
                <h5>
                  {'Hej'.translate(this.props.lang)}{' '}
                  <span>
                    {this.props.uData.userData &&
                    this.props.uData.userData.nickName
                      ? this.props.uData.userData.nickName
                      : this.props.uData.username}
                  </span>
                </h5>
                <div className="image-blocks">

                  <Row>
                    {showBackyard && <Col lg="12">
                      <Link to="/backyard">
                        <div style={{ position: 'relative' }}>
                          <img src={backyard} />
                          <h6
                              className="text-center"
                              style={{
                                position: 'absolute',
                                bottom: '20px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '100%',
                                textAlign: 'center'
                              }}
                          >
                            {'SE ALLA PRODUKTER'.translate(this.props.lang)}
                          </h6>
                        </div>
                      </Link>
                    </Col> }
                    <Col lg="6">
                      <Link to="/account/orders">
                        <div>
                          <img src={image1} />
                          <h6>{'MINA ORDRAR'.translate(this.props.lang)}</h6>
                        </div>
                      </Link>
                    </Col>
                    <Col lg="6">
                      <Link to="/account/orders">
                        <div>
                          <img src={image2} />
                          <h6>{'SPÅRA PAKET'.translate(this.props.lang)}</h6>
                        </div>
                      </Link>
                    </Col>
                    <Col lg="6">
                      <Link to="/account/return-goods">
                        <div>
                          <img src={image3} />
                          <h6>{'RETURNERA'.translate(this.props.lang)}</h6>
                        </div>
                      </Link>
                    </Col>
                    <Col lg="6">
                      <Link to="/kontakt">
                        <div>
                          <img src={image4} />
                          <h6>{'KONTAKTA OSS'.translate(this.props.lang)}</h6>
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page(AccountPageL);
